/**
 * Catalog for the `{{` variable autocomplete in the prompt editor.
 *
 * Scope (per product): `user.*` only. These match exactly what the runtime's
 * `loadEndUserMeta` exposes, so every offered token resolves at runtime.
 * `company.*` is intentionally omitted until workspace metadata is wired
 * (it has no data source yet); `context.*` is covered by the `#` picker.
 */

export interface VarItem {
  /** Field key after `user.` (e.g. "email"). */
  field: string;
  /** Human label shown in the list. */
  label: string;
  /** The full token inserted on select, e.g. `{{user.email}}`. */
  token: string;
}

export const USER_VARS: readonly VarItem[] = [
  { field: "name", label: "Name", token: "{{user.name}}" },
  { field: "displayName", label: "Display name", token: "{{user.displayName}}" },
  { field: "email", label: "Email", token: "{{user.email}}" },
  { field: "phone", label: "Phone", token: "{{user.phone}}" },
  { field: "locale", label: "Locale", token: "{{user.locale}}" },
  { field: "timezone", label: "Timezone", token: "{{user.timezone}}" },
];

/**
 * Filter the catalog by the text typed after `{{`. Tolerates a leading
 * `user.` so both `{{em` and `{{user.em` surface Email; matches field key
 * or label, case-insensitively.
 */
export function filterVars(query: string): VarItem[] {
  const q = query.trim().toLowerCase().replace(/^user\.?/, "");
  if (!q) return [...USER_VARS];
  return USER_VARS.filter(
    (v) => v.field.toLowerCase().includes(q) || v.label.toLowerCase().includes(q),
  );
}
